

AFRAME.registerComponent('poster', {
  schema: {
    srcWebp: {type: 'string'},
    srcLegacy: {type: 'string'},
    linkHeight: {default: 3.00},
    website: {default: ''},
    enabled: {default: true},
  },

  init: function (data) {
  },

  update: function () {
    // console.log("poster update   this.data:", this.data);

    if (this.data.srcLegacy || this.data.srcWebp) {
      const id = 'z' + Math.round(Math.random()*Number.MAX_SAFE_INTEGER).toString(36);

      let src = window.supportsWebP ? this.data.srcWebp : this.data.srcLegacy;
      if (!src) {
        src = this.data.srcLegacy || this.data.srcWebp;
      }
      // console.log('poster:', window.supportsWebP, id, src);

      const asset = document.createElement('img');
      asset.id = id;
      asset.src = src;
      asset.crossOrigin = "anonymous";
      document.querySelector('a-assets').append(asset);

      this.el.setAttribute('material', {shader: 'flat', src: '#'+id});
      if (this.data.enabled) {
        this.el.setAttribute('event-set__leave', {'_event': 'mouseleave', 'material.src': '#' + id});
      }
    }

    if (this.data.enabled && this.data.website) {
      this.el.addEventListener('click', evt => {
        // console.log("poster click:", evt.detail.intersection.point);
        if (evt.detail.intersection.point.y > this.data.linkHeight) {
          window.open(this.data.website);
        }
      });
    }
  },
});
